import React, { useState, useEffect, useRef, createRef } from 'react';
import styled from 'styled-components';

import ProductAddToCart from './product-add-to-cart';
import CustomProductAddToCart from './custom-product-add-to-cart';
import WishlistButton from './product-wishlist-button';
import { TransitionMixin, media } from '../helpers';

import PlusIcon from '../../images/icons/plus-circle.inline.svg';
import MinusIcon from '../../images/icons/minus-circle.inline.svg';
import { FaChevronDown } from 'react-icons/fa';

import RecycleIcon from '../../images/icons/recycle.inline.svg';
import RulerIcon from '../../images/icons/ruler.inline.svg';
import DecStar from '../../images/icons/dec-star.inline.svg';
import Star from '../../images/icons/star.inline.svg';
import CustomizeIcon from '../../images/icons/customize.inline.svg';

const ProductDetailsContainer = styled.div`
    flex: 1;

    .primary-collection {
        margin-bottom: 5px;
        a {
            color: #000;
            font-size: 0.9rem;
        }
    }
    .title-container {
        display: flex;
        align-items: center;
        .title {
            flex: 3;
            h1 {
                margin: 0;
                color: #000;
                font-family: 'neue-kabel', sans-serif;
                font-size: 2rem;
                line-height: 1.3;
                font-weight: 800;
                ${media.large`font-size: 2.8rem;line-height: 1.1;`}
            }
        }

        .price {
            flex: 1;
            text-align: right;
            p {
                margin: 0;
                font-family: sofia-pro, sans-serif;
                font-size: 1rem;
                font-weight: bold;
                color: #000;
            }
        }
    }

    .additional-info-wrapper {
        display: flex;
        /* align-items: flex-end; */
        padding: 20px 0 10px;
        ${media.medium`padding: 20px 0;`}

        .icons-container {
            flex: 1;

            .item-container {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0px;
                }

                .icon {
                    margin-right: 10px;
                    min-width: 30px;
                    text-align: center;
                    svg {
                        position: relative;
                        top: 2px;
                        max-width: 20px;
                        height: auto;
                    }
                }

                p {
                    margin: 0;
                    font-size: 0.8rem;
                }
            }
        }
        .stars-container {
            flex: 1;
            display: flex;
            flex-direction: column;

            .customize-toggle {
                flex: 1;

                button {
                    padding: 0;
                    border: none;
                    background-color: transparent;
                    font-size: 0.8rem;
                    text-decoration: underline;
                    ${TransitionMixin('.25s')};

                    span {
                        position: relative;
                        top: 2px;
                        margin-right: 7px;
                        text-decoration: none;
                    }

                    &:hover {
                        opacity: 0.7;
                    }
                }
            }

            .inner-wrap {
                display: flex;

                p {
                    margin: 0 0 0 10px;
                    font-size: 0.8rem;
                }
            }
        }

        .size-guide {
            flex: 1;
            text-align: right;
            display: none;
            align-self: flex-end;
            ${media.large`display: block;`}

            a {
                color: #000;
            }
        }
    }

    .variants-container {
        display: flex;
        flex-wrap: wrap;

        .selectors-container {
            display: flex;
            padding-top: 20px;
            flex: 1 1 100%;
            margin-bottom: 20px;
            ${media.large`flex: 2; margin-bottom: 0px;`}
            .select-container {
                flex: 1;
                position: relative;
                margin-right: 20px;
                &:last-child {
                    margin-right: 0px;
                    ${media.large`margin-right: 20px;`}
                }

                h4 {
                    margin: 0 0 10px;
                    font-size: 0.9rem;
                    display: inline-block;
                    color: #000;
                }

                select {
                    box-sizing: border-box;
                    width: 100%;
                    line-height: 1;
                    outline-offset: 0px;
                    padding: 9.5px 10px 12.5px;
                    background-color: #f2f0eb;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    -o-appearance: none;
                    border-radius: 5px;
                    border: 1px solid #f2f0eb;

                    /* everything after this is just to cover up the original arrow */
                    /* (for browsers that don't support the syntax used above) */
                    padding-right: 5px;

                    &.select-class {
                        font-size: 0.9rem;
                    }
                }
                svg {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                    pointer-events: none;
                }
            }
        }
        .qty-outer-container {
            flex: 1;
            display: flex;

            .qty-container {
                display: inline-flex;
                align-items: flex-end;
                flex: 0 0 50%;

                .input-container {
                    h4 {
                        margin: 0 0 10px;
                        font-size: 0.9rem;
                        color: #000;
                    }
                    input {
                        height: 40px;
                        max-width: 60px;
                        background-color: #f2f0eb;
                        border: 1px solid #767676;
                        margin-right: 15px;
                        border-radius: 5px;
                        -webkit-appearance: none;
                        text-align: center;
                        &::-webkit-outer-spin-button,
                        &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }
                    }
                }
                .btn-container {
                    display: flex;
                    align-items: baseline;
                    button {
                        line-height: 1;
                        border: none;
                        background-color: #fff;
                        padding: 0;

                        &:hover {
                            opacity: 0.6;
                        }

                        svg {
                            stroke-width: 1.3px;
                            height: 32px;
                            width: 32px;
                        }
                    }
                }
            }
            .mobile-wishlist {
                flex: 0 0 50%;
                align-self: flex-end;
                ${media.large`display: none;`}
            }
        }
    }
    .product-description-container {
        padding-top: 20px;
    }

    .custom-pricing-container {
        margin-top: 30px;
        h4 {
            margin: 0 0 10px;
            color: #000;
            font-size: 0.9rem;
            font-weight: 700;
        }
        p {
            margin: 0;
            color: #000;

            &.total {
                font-size: 2.1rem;
                line-height: 1;
                font-weight: 700;
                margin-bottom: 10px;
            }

            &.per-unit {
                font-size: 0.8rem;
                span {
                    color: #f74d33;
                }
            }
        }
    }
`;

const ProductDetails = ({
    product,
    currentVariant,
    handleVariantChange,
    qty,
    setQty,
    custom,
    setIsCustomizerOpen,
    currentPalette,
    setIsSizeGuideOpen,
}) => {
    // all variants
    const [variantSelectors, setVariantSelectors] = useState(product.variants);

    // variant price
    const { price } = currentVariant || {};

    // variant selectors logic
    let variantSelectObj = [];
    let allOptions = [];

    variantSelectors.map((selector) =>
        selector.selectedOptions.map((option) => {
            allOptions.push(option);
        })
    );

    function removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    allOptions = removeDuplicates(allOptions, 'value');

    // setup selects
    variantSelectors[0].selectedOptions.map((option) => {
        let newObj = {
            name: option.name,
            options: [
                allOptions.filter(
                    (childOption) => childOption.name === option.name
                ),
            ],
        };
        variantSelectObj.push(newObj);
    });

    const selectorRefs = useRef(variantSelectObj.map(() => createRef()));

    // handle select changes
    function handleSelectChange() {
        // filter all variants using the select refs
        let newVariant = [];
        variantSelectors.map((variant) => {
            let doesVariantHaveAllAttributes = 0;
            selectorRefs.current.map((ref) => {
                variant.selectedOptions.map((option) => {
                    if (ref.current.value === option.value) {
                        // console.log('match');
                        doesVariantHaveAllAttributes =
                            doesVariantHaveAllAttributes + 1;
                    }
                });
                if (doesVariantHaveAllAttributes === variantSelectObj.length) {
                    // console.log('yooo', doesVariantHaveAllAttributes);
                    return newVariant.push(variant);
                }
            });
        });

        if (newVariant.length > 0) {
            handleVariantChange(newVariant[0]);
        }
    }

    // setup description

    function generateDescription() {
        return { __html: product.descriptionHtml };
    }

    const isBrowser = typeof window != 'undefined';
    function handleCustomizerOpen() {
        setIsCustomizerOpen(true);
        if (isBrowser) {
            window.history.pushState('page2', 'Title', '?customize');
        }
    }

    // fixes select text cutoff issue
    useEffect(() => {
        setTimeout(() => {
            selectorRefs &&
                selectorRefs.current.length > 0 &&
                selectorRefs.current.map((selectNode) => {
                    selectNode.current &&
                        selectNode.current.classList.add('select-class');
                });
        }, 1000);
    }, []);

    // qty control
    function updateQuantity(newValue) {
        setQty(newValue);
    }

    function handleOpenSizeGuide() {
        setIsSizeGuideOpen(true);
    }

    return (
        <ProductDetailsContainer>
            {!custom && (
                <>
                    <div className="primary-collection">
                        <a href="#">State Flag Collection</a>
                    </div>
                    <div className="title-container">
                        <div className="title">
                            <h1>{product.title}</h1>
                        </div>
                        <div className="price">
                            <p>${price}</p>
                        </div>
                    </div>
                </>
            )}

            {!custom && (
                <div className="additional-info-wrapper">
                    <div className="icons-container">
                        <div className="item-container">
                            <div className="icon">
                                <RecycleIcon />
                            </div>
                            <p>Recycled Fabric</p>
                        </div>
                        <div className="item-container">
                            <div className="icon">
                                <DecStar />
                            </div>
                            <p>Made in USA</p>
                        </div>
                        <div className="item-container">
                            <div className="icon">
                                <RulerIcon />
                            </div>
                            <p>Flexible sizing</p>
                        </div>
                    </div>
                    <div className="stars-container">
                        <div className="customize-toggle">
                            <button onClick={() => handleCustomizerOpen()}>
                                <span>
                                    <CustomizeIcon />
                                </span>
                                Customize this product
                            </button>
                        </div>
                        <div className="inner-wrap">
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>

                            <p>163 reviews</p>
                        </div>
                    </div>
                    <div className="size-guide">
                        <button onClick={() => handleOpenSizeGuide()}>
                            Size Guide
                        </button>
                    </div>
                </div>
            )}

            <div className="variants-container">
                <div className="selectors-container">
                    {variantSelectObj &&
                        variantSelectObj.map((selector, index) => {
                            return (
                                <div className="select-container" key={index}>
                                    <h4>{selector.name}</h4>
                                    <select
                                        ref={selectorRefs.current[index]}
                                        onChange={(e) => handleSelectChange(e)}
                                        // value={}
                                    >
                                        {selector.options[0].map((option) => {
                                            return (
                                                <option value={option.value}>
                                                    {option.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <FaChevronDown />
                                </div>
                            );
                        })}
                </div>
                <div className="qty-outer-container">
                    <div className="qty-container">
                        <div className="input-container">
                            <h4>Quantity</h4>
                            <input type="number" value={qty} />
                        </div>
                        <div className="btn-container">
                            <button onClick={() => updateQuantity(qty + 1)}>
                                <PlusIcon />
                            </button>
                        </div>
                        <div className="btn-container">
                            <button
                                onClick={() =>
                                    qty !== 1 ? updateQuantity(qty - 1) : ''
                                }
                            >
                                <MinusIcon />
                            </button>
                        </div>
                    </div>
                    <div className="mobile-wishlist">
                        <WishlistButton />
                    </div>
                    {custom && (
                        <div className="custom-size-guide">
                            <a href="#">Size Guide</a>
                        </div>
                    )}
                </div>
                {custom && price && (
                    <div className="custom-pricing-container">
                        <h4>Price</h4>
                        <p className="total">${qty * price}</p>
                        <p className="per-unit">
                            {' '}
                            per unit <span>${price.replace('.00', '')}</span>
                        </p>
                    </div>
                )}
            </div>
            {custom ? (
                <CustomProductAddToCart
                    handle={product.handle}
                    currentVariant={currentVariant}
                    qty={qty}
                    currentPalette={currentPalette}
                />
            ) : (
                <ProductAddToCart
                    handle={product.handle}
                    currentVariant={currentVariant}
                    qty={qty}
                />
            )}

            {/* <div className="product-description-container">
                <div
                    className="inner-wrap"
                    dangerouslySetInnerHTML={generateDescription()}
                ></div>
            </div> */}
        </ProductDetailsContainer>
    );
};

export default ProductDetails;
